// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
const REQUEST_PAGE_DATA = 'REQUEST_PAGE_DATA';
const REQUEST_PAGE_DATA_SUCCESS = 'REQUEST_PAGE_DATA_SUCCESS';

export {
  REQUEST_PAGE_DATA,
  REQUEST_PAGE_DATA_SUCCESS,
};
